import {getDeliveryAddressFee} from '@web/actions/deliveryInfo'
import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import makeSlice from '@web/slices/deliveryGroup/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'
import {convertDeliveryGroupsByKey} from '../../utils/delivery'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByStorage.fulfilled, (state, {payload}) => {
                if (payload.differences.includes('DELIVERY')) {
                    // 배송지를 복원하면 배송비를 재조회해 오지만, 깜빡임을 최소화 하기위한 복원 로직
                    state.deliveryGroupsByKey = payload.data.deliveryGroup.deliveryGroupsByKey
                }
            })
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                state.deliveryGroupsByKey = convertDeliveryGroupsByKey(payload.delivery.deliveryGroupsByKey)
            })
            .addCase(getDeliveryAddressFee.fulfilled, (state, {payload}) => {
                const {delivery} = payload.data
                state.deliveryGroupsByKey = convertDeliveryGroupsByKey(delivery.deliveryGroupsByKey)
            })
    },
})

export default slice.reducer
